import React, { useState } from 'react';
import clsx from 'clsx';
import { Text, Button } from '@/components';
import { useApp } from '@/hooks';
import './Accordion.scss';

type AccordionItemProps = {
  tabTitle: string;
  title : string;
  description: string;
  icon: string;
  activeIcon: string;
  contentImage: string;
  isOpen: boolean;
  onClick: () => void;
};
const AccordionItem = ({
  tabTitle,
  title,
  description,
  icon,
  activeIcon,
  contentImage,
  isOpen,
  onClick
}: AccordionItemProps) => (
  <div className={clsx(
    "flex flex-col items-start custom-accordion-header",
    {
      "active": isOpen
    }
  )}>
     <div className="w-full">
      <div
        className={clsx(
          "ask-answer-act-tab relative w-full px-2.5 py-3 flex justify-between items-center custom-accordion-header-inner",
          {
            "active-tab pb-[10px]": isOpen,
          }
        )}
        onClick={onClick}
      >
        {isOpen && (
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
        )}
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8">
            <img
              src={isOpen ? activeIcon : icon}
              alt="Toggle Icon"
              className="w-full h-auto"
              loading="lazy" // Added lazy loading
            />
          </div>

          <Text.Description
            size="sm"
            className={`justify-start text-[16px] text-left font-500 ${isOpen ? 'text-black' : 'text-[#555555]' }`}
          >
            {tabTitle}
          </Text.Description>
        </div>

        {isOpen ? (
          <img
            src="/images/home/active-up.svg"
            alt="Toggle Icon"
            className="w-2.5 h-2.5"
            loading="lazy" // Added lazy loading
          />
        ) : (
          <img
            src="/images/home/down.svg"
            alt="Toggle Icon"
            className="w-2.5 h-2.5"
            loading="lazy" // Added lazy loading
          />
        )}
      </div>
      
      {isOpen && (
        <>
          <div className="flex flex-col gap-2 px-[14px] py-5">
            <Text.Description size="lg" className="text-left !text-[18px] text-black !font-semibold">
              {title}
            </Text.Description>

            <Text.Description size="md" className="text-left !text-[#383838]">
              {description}
            </Text.Description>
          </div>

          <div className="bg-[#F9F9F9] rounded-[12px] mb-5 p-5 content-image-wrapper">
            <img
              src={contentImage}
              alt="Content"
              className="w-full h-full object-cover rounded-[12px]"
              loading="lazy" // Added lazy loading
            />
          </div>
        </>
      )}
     </div>
  </div>
);


type CustomAccordionProps = {
  items: {
    tabTitle: string;
    title : string;
    description: string;
    icon: string;
    activeIcon: string;
    contentImage: string;
  }[];
  activeTab: number;
  setActiveTab: (index: number) => void;
};
export const CustomAccordion = ({ items, activeTab, setActiveTab }: CustomAccordionProps) => {
  const { doGetStarted } = useApp();

  const handleToggle = (index: number) => {
    setActiveTab(activeTab === index ? 0 : index);
  };

  return (
    <div className="w-full">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          tabTitle={item.tabTitle}
          title={item.title}
          description={item.description}
          icon={item.icon}
          activeIcon={item.activeIcon}
          contentImage={item.contentImage}
          isOpen={activeTab === index}
          onClick={() => handleToggle(index)}
        />
      ))}

      <div className="w-full mt-8 px-2">
        <Button
          className="w-full h-[56px] border-none"
          onClick={doGetStarted}
        >
          <span className="font-semibold text-[18px] text-center leading-[27px] font-inter">
            Get Start - 14 Day Free Trial
          </span>
        </Button>

        <Text.Description size="sm" className="!text-[14px] !text-[#424242] text-center mt-2">
          No credit card required
        </Text.Description>
      </div>
    </div>
  );
};
